import { useKeystoneSession } from '../auth/use-keystone-session';
import { useCallback, useEffect, useState } from 'react';

import { fetchTax } from '../external-endpoints/fetch-tax';
import { useDesign } from './use-design';
import { customerState, projectState, useAppSelector } from '@state';

export const useTax = (): [number, string | null, () => Promise<void>, boolean] => {
	const [controller] = useDesign();
	const { getToken } = useKeystoneSession();
	const customer = useAppSelector(customerState);
	const project = useAppSelector(projectState);

	const kitchenData = controller?.kitchen ?? null;

	const [tax, setTax]	= useState<number>(kitchenData?.tax ?? 0);
	const [error, setError] = useState<string | null>(null);
	const [isCalculating, setIsCalculating] = useState<boolean>(false);

	useEffect(() => {
		if (kitchenData && kitchenData.tax !== tax) {
			kitchenData.tax = tax;
		}
	}, [kitchenData, tax]);

	const calculateTax = useCallback(async () => {
		if (kitchenData !== null) {
			setIsCalculating(true);
			setError(null);

			// Use the associated deal's address for tax — dealers control deal data
			const deal = project.find((d) => d.dealId === kitchenData.dealId) ?? project?.[0];
			const taxCustomer = deal
				? {
					...customer,
					zipcode: deal.zip ?? customer.zipcode,
					address: deal.address ?? customer.address,
					city: deal.city ?? customer.city,
					state: deal.state ?? customer.state
				}
				: customer;

			const [taxResponse] = await fetchTax({
				kitchen: kitchenData,
				customer: taxCustomer,
				getToken,
				setTax,
				setError
			});
			if (taxResponse !== null) {
				kitchenData.tax = taxResponse.totalTax;
			}
			setIsCalculating(false);
		}
	}, [kitchenData, customer, project, getToken]);

	return [tax, error, calculateTax, isCalculating];
};
